import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const MobileCtaBar = () => {
  const { pathname } = useLocation();

  // The contact page is the enquiry form itself — don't cover it with a CTA to reach it.
  if (pathname === '/contact') return null;

  return (
    <div className="mobile-cta-bar">
      <Link to="/contact" className="hero-cta hero-cta-primary" data-track="mobile_bar">Check Availability</Link>
      <a href="tel:+19132389020" className="hero-cta hero-cta-secondary" data-track="mobile_bar">
        Call Us
      </a>
    </div>
  );
};

export default MobileCtaBar;
